import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { ErrorService } from '../../providers/error/error.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  public error = this.errorService.error;
  constructor(public errorService: ErrorService) { }
}
